module.exports = __webpack_public_path__ + "img/marketer-active.b86cd15.svg";